import { IProductDetail } from "interfaces/IProductDetail"
import Skeleton from "react-loading-skeleton"

const ProductDetail = ({ fields, hasPlaceHolder = true, isReserva = false }: IProductDetail) => {
  const labelKeyReversa = "Cantidad a Enviar";
  return (
    <>
      {fields.map((field) => {
        const [label, value] = field
        const isCustomReserva = isReserva && label === labelKeyReversa
        return (
          <p key={label}>
            {isCustomReserva ? (
              // Comportamiento custom para Reserva
              <>
                <span className="relevant-title"> {label}: </span>
                {value}
              </>
            ) : value ? (
              // Comportamiento actual
              <>
                <span className="relevant-title"> {label}: </span>
                {value}
              </>
            ) : (
              <>{hasPlaceHolder ? <Skeleton width={150} /> : null}</>
            )}
          </p>
        )
      })}
    </>
  )
}

export default ProductDetail
